import { injectable } from 'inversify';

import {
  DtoBase,
  Enums,
  TenantModels,
  UIDtoFactory,
} from '@project44-models/iam-gateway';

import { ITenantFactory } from '../../domain/interfaces';

@injectable()
export class TenantFactory implements ITenantFactory {
  public createDto(
    tenant?: TenantModels.TenantViewModel,
  ): DtoBase<TenantModels.TenantViewModel> {
    return UIDtoFactory.create(Enums.UiDtoFactoryEnum.TENANT, tenant || {});
  }

  public createTenantQueryResultsDto(
    queryResults: TenantModels.TenantQueryResultsViewModel,
  ): DtoBase<TenantModels.TenantQueryResultsViewModel> {
    return new DtoBase<TenantModels.TenantQueryResultsViewModel>({
      model: queryResults,
    });
  }

  public createTenantQueryDto(
    query: TenantModels.TenantQueryViewModel,
  ): DtoBase<TenantModels.TenantQueryViewModel> {
    return new DtoBase<TenantModels.TenantQueryViewModel>({
      model: query,
    });
  }
}
